import "./static/styles/main.css";
import { setAppElement } from "components/src/components/Elements/Modal/Modal";

const APP_ELEMENT_SELECTOR = '#___gatsby';

export const onClientEntry = () => {
  setAppElement(APP_ELEMENT_SELECTOR);
};
